/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class OfferApiConfiguration {
  rootUrl: string = '/';
}

/**
 * Parameters for `OfferApiModule.forRoot()`
 */
export interface OfferApiConfigurationParams {
  rootUrl?: string;
}
